// extracted by mini-css-extract-plugin
export default {"descriptionTable":"profile_descriptionTable__RP2fx","row":"profile_row__6XLVC"};